import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Backdrop,
  Grid,
  Col,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@common/components';
import cx from 'classnames';
import modalClasses from './Modal.module.scss';

export default function Modal({
  visible,
  className,
  children,
  onClose,
  closeOnClickOutside,
}) {
  const cs = cx(modalClasses.modal, className);
  const [visibility, setVisibility] = useState(visible);
  useEffect(() => {
    setVisibility(visible);
  }, [visible]);

  useEffect(() => {
    if (visibility === false && onClose) {
      onClose();
    }
  }, [visibility]);

  const handleClickOutside = () => {
    if (closeOnClickOutside) {
      setVisibility(false);
    }
  };

  return visibility ? (
    <Backdrop onClick={() => handleClickOutside()}>
      <Card className={cs}>{children}</Card>
    </Backdrop>
  ) : null;
}

export function ModalHeader({ children, className }) {
  const cn = cx(modalClasses.header, className);
  return <CardHeader className={cn}>{children}</CardHeader>;
}

export function ModalContent({ children, className }) {
  const cn = cx(modalClasses.content, className);
  return <CardContent className={cn}>{children || ''}</CardContent>;
}

export function ModalFooter({ children, className }) {
  const cn = cx(modalClasses.footer, className);
  const childs =
    children instanceof Array ? children.filter((c) => c !== null) : [children];
  const itemSize = Math.ceil(12 / childs.length);
  return (
    <CardFooter className={cn}>
      <Grid align="middle" justify="center">
        {childs.map((child, index) => (
          <Col
            flex
            key={`button_acttion_${index}`}
            justify="center"
            xs={itemSize}
          >
            {child}
          </Col>
        ))}
      </Grid>
    </CardFooter>
  );
}

ModalContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

ModalHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

ModalFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

Modal.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
  children: PropTypes.node,
  closeOnClickOutside: PropTypes.bool,
  onClose: PropTypes.func,
};
